import { Component, OnInit } from '@angular/core';
import { AccessaryService } from 'src/app/shared/services/accessary.service';
import { Category } from './accessory-cat.model';
import { Banner } from '../home/home.model';
import { BannerService } from 'src/app/shared/services/banner.service';
declare var $: any;
@Component({
    selector: 'app-accessory-cat',
    templateUrl: './accessory-cat.component.html',
    styleUrls: ['./accessory-cat.component.scss']
})
export class AccessoryCatComponent implements OnInit {
    constructor(private type: AccessaryService, private bannerService: BannerService) {}

    cat: Category;
    banners: Banner;
    ngOnInit() {
        this.getAccessoryType();

        this.bannerService.getBanner('adsLeft').subscribe((res: Banner) => {
            this.banners = res;
        });
    }

    getAccessoryType() {
        this.type.getType().subscribe((res: Category) => {
            this.cat = res;
        });
    }
}
